import {combineReducers} from 'redux'
import dataPlantilla from './dataReducer'

const Reducers = combineReducers({
    dataPlantilla
})

export default Reducers 